import React from "react";

import { Box, Typography, Button } from "@mui/material";
import Modal from "@mui/material/Modal";
import { makeStyles, withStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

type ModalProps = {
  visibility: boolean;
  onClose: () => void;
  onCancel: () => void;
};
const useStyles = makeStyles()((theme) => ({
  root: {
    overflowY: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
  },
  modalBody: {
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(24, 24),
    backgroundColor: colors.white,
    overflowY: "auto",
    width: "470px",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      margin: 0,
    },
  },
  content: {
    padding: "40px",
    [theme.breakpoints.down("md")]: {
      padding: "24px",
    },
  },
  header: {
    fontSize: "20px",
    fontWeight: 700,
    marginBottom: "20px",
  },
  message: {
    fontSize: "16px",
    fontWeight: 600,
    marginBottom: "20px",
    textAlign: "center",
  },
}));

const StyledCancelButton = withStyles(Button, {
  root: {
    color: "#FF6262",
    border: "2px solid #FF6262",
    marginRight: 8,
    "&:hover": {
      color: "#FF6262",
      border: "2px solid #FF6262",
    },
  },
});

const CancelCreateAppointmentModal: React.FC<ModalProps> = ({
  visibility,
  onClose,
  onCancel,
}) => {
  const { classes } = useStyles();

  return (
    <>
      <Modal open={visibility} onClose={onClose} className={classes.root}>
        <Box className={classes.modalBody}>
          <div>
            <Box className={classes.content}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Typography className={classes.header}>
                  Don&apos;t want to continue?
                </Typography>
              </Box>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Typography className={classes.message}>
                  Cancelling will not save any data you entered on this new
                  apppointment.
                </Typography>
              </Box>
              <Box display="flex" justifyContent="center" alignItems="center">
                <StyledCancelButton
                  variant="outlined"
                  onClick={() => {
                    onClose();
                    onCancel();
                  }}
                >
                  Yes, I want to cancel
                </StyledCancelButton>
                <Button color="primary" onClick={onClose}>
                  Continue Working
                </Button>
              </Box>
            </Box>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default CancelCreateAppointmentModal;
